<template>
  <div>
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据统计</el-breadcrumb-item>
      <el-breadcrumb-item>月度进货销售统计</el-breadcrumb-item>
    </el-breadcrumb>

    <!--卡片视图区域-->
    <el-card>
      <!-- 年份选择 + 刷新按钮 -->
      <el-row :gutter="20" style="margin-bottom: 20px; align-items: center;">
        <el-col :span="4">
          <el-select 
            v-model="selectedYear" 
            placeholder="选择年份" 
            style="width: 120px; margin-right: 10px;"
            @change="getMonthSummaryData"
          >
            <el-option 
              v-for="year in yearOptions" 
              :key="year" 
              :label="year + '年'" 
              :value="year"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button 
            type="primary" 
            icon="el-icon-refresh" 
            @click="getMonthSummaryData"
          >
            刷新数据
          </el-button>
        </el-col>
      </el-row>

      <!-- 月度统计表格（固定表头） -->
      <div style="overflow-x: auto; max-height: 600px;">
        <el-table
          border
          :data="monthSummaryList"
          stripe
          :header-cell-style="{ position: 'sticky', top: 0, background: '#f5f7fa' }"
          size="medium"
        >
          <!-- 月份 -->
          <el-table-column 
            prop="month" 
            label="月份" 
            width="80" 
            align="center"
            fixed="left"
          />
          
          <!-- 进货相关字段 -->
          <el-table-column 
            prop="inNum" 
            label="进货数量(kg)" 
            width="100" 
            align="center"
          />
          <el-table-column 
            prop="inMoney" 
            label="进货总额(元)" 
            width="100" 
            align="center"
          />
          <el-table-column 
            prop="inCount" 
            label="进货次数" 
            width="80" 
            align="center"
          />
          <el-table-column 
            prop="inTopFactory" 
            label="进货最多" 
            width="120" 
            align="center"
            show-overflow-tooltip
          />
          <el-table-column 
            prop="inTopFactoryNum" 
            label="进货最多(kg)" 
            width="110" 
            align="center"
          />
          <el-table-column 
            prop="inTopFactoryMoney" 
            label="进货最多(元)" 
            width="110" 
            align="center"
          />
          
          <!-- 销售相关字段 -->
          <el-table-column 
            prop="outNum" 
            label="销售数量(kg)" 
            width="100" 
            align="center"
          />
          <el-table-column 
            prop="outMoney" 
            label="销售总额(元)" 
            width="100" 
            align="center"
          />
          <el-table-column 
            prop="outCount" 
            label="销售次数" 
            width="80" 
            align="center"
          />
          <el-table-column 
            prop="outTopFactory" 
            label="销售最多" 
            width="120" 
            align="center"
            show-overflow-tooltip
          />
          <el-table-column 
            prop="outTopFactoryNum" 
            label="销售最多(kg)" 
            width="110" 
            align="center"
          />
          <el-table-column 
            prop="outTopFactoryMoney" 
            label="销售最多(元)" 
            width="110" 
            align="center"
          />
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import $httpREQUEST from '@/utils/request';
import PUBTOOLS from '@/utils/pubtools';
export default {
  name: "yuedata",
  data() {
    return {
      // 月度统计数据列表
      monthSummaryList: [],
      // 选中的年份
      selectedYear: new Date().getFullYear(),
      // 年份选项（近10年）
      yearOptions: []
    };
  },
  created() {
    // 生成年份选项（近10年）
    const currentYear = new Date().getFullYear();
    this.yearOptions = Array.from({ length: 10 }, (_, i) => currentYear - i);
    // 页面加载时自动获取数据
    this.getMonthSummaryData();
  },
  methods: {
    /**
     * 获取月度进货销售统计数据
     */
    async getMonthSummaryData() {
      try {
        const { data: res } = await $httpREQUEST.get('/api/showData/monthRank', {
          params:PUBTOOLS.addParams({
            year: this.selectedYear
          })
        });
        
        if (res.status !== 0) {
          return this.$message.error('获取月度统计数据失败：' + res.message);
        }
        
        this.monthSummaryList = res.data;
        this.$message.success('获取月度统计数据成功');
      } catch (err) {
        console.error('获取月度统计数据异常：', err);
        this.$message.error('获取月度统计数据失败，请重试');
      }
    }
  }
};
</script>

<style scoped>
/* 表格表头固定样式优化 */
.el-table th {
  background-color: #f5f7fa !important;
  font-weight: normal;
}

/* 表格单元格内边距优化 */
.el-table td, .el-table th {
  padding: 8px 0 !important;
}

/* 滚动条样式优化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #ccc;
}
::-webkit-scrollbar-track {
  background: #f5f5f5;
}

/* 选择器和按钮行样式优化 */
.el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>